// extracted by mini-css-extract-plugin
export var articlePageContainer = "j_K";
export var articlePostContainer = "j_L";
export var articlePostEditorial = "j_M";
export var articleSourcesContainer = "j_P";
export var customArticleCard = "j_Q";
export var infoContainer = "j_J";
export var pageContent = "j_N";
export var relatedArticles = "j_R";